export default __webpack_public_path__ + "static/media/headshot-james.0a57f6f3.png";